import { render, staticRenderFns } from "./CheeseVideoList.vue?vue&type=template&id=27be21e2&"
import script from "./CheeseVideoList.vue?vue&type=script&lang=js&"
export * from "./CheeseVideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports